import styled from 'styled-components';
import { maxSize, px2percent, px2vw } from '../../Utils/common';
import { themeColor } from '../../Utils/magicStrings';
import { ARROW_STYLE, POINT_STYLE,  } from './Swiper';

export const SwiperWrapper = styled('div')`
    position: relative;
    width: 100%;
    ${props => maxSize(props.height, props.styleType, 'height')};
`;

export const PictureWrapper = styled('div')`
    display: inline-block;
    width: 100%;
    height: 100%;
    img {
        width: 100%;
        height: 100%;
    }
`;

export const Arrow = styled('div')`
    position: absolute;
    ${props => getArrowStyle(props.position, props.arrowStyle, props.styleType, props.hover)}
`

export const PictureLine = styled('div')`
    position: relative;
    height: 100%;
    white-space: nowrap;
    transform: translate(${props => -1 * props.position.index * props.step + props.first}%);
    transition: ${props => props.needAnimation && props.position.hasAnimation ? 'transform 1s ease-in-out' : ''};
`;

export const DisplayZone = styled('div')`
    overflow: hidden;
    width: 100%;
    height: 100%;
`;


export const Point = styled('div') `
    ${props => getPointStyle(props.pointStyle, props.checked, props.styleType)};
`;

export const PointWrapper = styled('div')`
    position: absolute;
    z-index: 3;
    ${props => getPointWrapperStyle(props.pointStyle, props.styleType)}
`;


function getArrowStyle(position ,style, styleType, hover) {
    switch(style) {
        case ARROW_STYLE.BIG_CIRCLE: 
            return `
                background-color: ${hover ? '#D1BB8B': themeColor};
                ${maxSize(89, styleType, 'width')};
                ${maxSize(89, styleType, 'height')};
                border-radius: 50%;
                ${maxSize(-68, styleType, 'bottom')};
                ${position === 'left' ? `${maxSize(174, styleType, 'right')}` : `${maxSize(61, styleType, 'right')}`};
                & #arr {
                    ${maxSize(23, styleType, 'width')};
                    ${maxSize(23, styleType, 'height')};
                    border-top: 2px solid ${hover ? '#FFF6E7': 'white'};
                    border-left: 2px solid ${hover ? '#FFF6E7': 'white'};
                    position: absolute;
                    top: 50%;
                    ${position === 'left' ? 'left: 40%; transform: rotate(-45deg) translate(5%, -65%);' :
                    'transform: rotate(135deg) translate(0, 70%); right: 16%;'};
                }
                & #line {
                    ${maxSize(40, styleType, 'width')};
                    border: 1px solid ${hover ? '#FFF6E7': 'white'};
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            `
        case ARROW_STYLE.WHITE_CIRCLE: 
            return `
            background-color: ${hover ? '#8F7951': 'transparent'};
            ${maxSize(89, styleType, 'width', 55)};
            ${maxSize(89, styleType, 'height', 55)};
            border-radius: 50%;
            border: 1px solid ${hover ? '#8F7951': 'black'};
            ${maxSize(208, styleType, 'top', 158)};
            ${position === 'left' ? `${maxSize(-55, styleType, 'left', -18)}` : `${maxSize(-55, styleType, 'right', -18)}`};
            & #arr {
                ${maxSize(23, styleType, 'width', 14)};
                ${maxSize(23, styleType, 'height', 14)};
                border-top: 1px solid ${hover ? '#F8F5F1': 'black'};
                border-left: 1px solid ${hover ? '#F8F5F1': 'black'};
                position: absolute;
                top: 50%;
                ${position === 'left' ? 'left: 40%; transform: rotate(-45deg) translate(5%, -65%);' :
                'transform: rotate(135deg) translate(0, 70%); right: 16%;'};
            }
            & #line {
                ${maxSize(40, styleType, 'width', 24)};
                border-top: 1px solid ${hover ? '#F8F5F1': 'black'};
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
            `
        case ARROW_STYLE.WHITE_CIRCLE_2: 
            return `
                background-color: ${hover ? '#8F7951': 'transparent'};
                ${maxSize(53, styleType, 'width', 39)};
                ${maxSize(53, styleType, 'height', 39)};
                border-radius: 50%;
                border: 1px solid ${hover ? '#8F7951': 'white'};
                ${maxSize(13, styleType, 'bottom', 89)};
                ${position === 'left' ? `${maxSize(98, styleType, 'right', 288)}` : `${maxSize(21, styleType, 'right', 16)}`};
                & #arr {
                    ${maxSize(14, styleType, 'width', 10)};
                    ${maxSize(14, styleType, 'height', 10)};
                    border-top: 1px solid ${hover ? '#F8F5F1': 'white'};
                    border-left: 1px solid ${hover ? '#F8F5F1': 'white'};
                    position: absolute;
                    top: 50%;
                    ${position === 'left' ? 'left: 40%; transform: rotate(-45deg) translate(5%, -65%);' :
                    'transform: rotate(135deg) translate(0, 70%); right: 16%;'};
                }
                & #line {
                    ${maxSize(24, styleType, 'width', 17)};
                    border-top: 1px solid ${hover ? '#F8F5F1': 'white'};
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            `
            case ARROW_STYLE.WHITE_CIRCLE_3: 
            return `
                background-color: ${hover ? '#8F7951': 'transparent'};
                ${maxSize(53, styleType, 'width', 34)};
                ${maxSize(53, styleType, 'height', 34)};
                border-radius: 50%;
                border: 1px solid ${hover ? '#8F7951': 'white'};
                ${maxSize(13, styleType, 'bottom', 89)};
                ${position === 'left' ? `${maxSize(98, styleType, 'right', 233)}` : `${maxSize(21, styleType, 'right', 8)}`};
                & #arr {
                    ${maxSize(14, styleType, 'width', 10)};
                    ${maxSize(14, styleType, 'height', 10)};
                    border-top: 1px solid ${hover ? '#F8F5F1': 'white'};
                    border-left: 1px solid ${hover ? '#F8F5F1': 'white'};
                    position: absolute;
                    top: 50%;
                    ${position === 'left' ? 'left: 40%; transform: rotate(-45deg) translate(5%, -65%);' :
                    'transform: rotate(135deg) translate(0, 70%); right: 16%;'};
                }
                & #line {
                    ${maxSize(24, styleType, 'width', 17)};
                    border-top: 1px solid ${hover ? '#F8F5F1': 'white'};
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            `
            case ARROW_STYLE.BIG_CIRCLE_2: 
            return `
                background-color: ${hover ? '#D1BB8B': themeColor};
                ${maxSize(53, styleType, 'width', 39)};
                ${maxSize(53, styleType, 'height', 39)};
                border-radius: 50%;
                ${maxSize(-80, styleType, 'bottom', 89)};
                ${position === 'left' ? `${maxSize(170, styleType, 'left', 288)}` : `${maxSize(141, styleType, 'right', 16)}`};
                & #arr {
                    ${maxSize(14, styleType, 'width', 10)};
                    ${maxSize(14, styleType, 'height', 10)};
                    border-top: 2px solid ${hover ? '#F8F5F1': 'white'};
                    border-left: 2px solid ${hover ? '#F8F5F1': 'white'};
                    position: absolute;
                    top: 50%;
                    ${position === 'left' ? 'left: 40%; transform: rotate(-45deg) translate(5%, -65%);' :
                    'transform: rotate(135deg) translate(0, 70%); right: 16%;'};
                }
                & #line {
                    ${maxSize(24, styleType, 'width', 17)};
                    border: 1px solid ${hover ? '#F8F5F1': 'white'};
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
        `
        default: 
            return '';
    }
}


function getPointWrapperStyle(style, styleType) {
    switch (style) {
        case POINT_STYLE.CIRCLE_COLUMN: 
            return `
                width: 2.22%;
                top: 50%;
                left: 94.7%;
                transform: translate(-50%, -50%);
                height: 25%;
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
            `
        case POINT_STYLE.CIRCLE_ROW: 
            return `
                ${maxSize(29, styleType, 'left')};
                ${maxSize(17, styleType, 'bottom')};
                width: 100%;
            `;
        case POINT_STYLE.POINT: 
            return `
                ${maxSize(320, styleType, 'right')};
                ${maxSize(-23, styleType, 'bottom')};
            `
        case POINT_STYLE.POINT_IN: 
            return `
                bottom: ${px2vw(16, 375)};
                left: 50%;
                transform: translate(-50%);
            `
        case POINT_STYLE.POINT_2: 
            return `
                ${maxSize(-60, styleType, 'bottom')};
                left: 50%;
                transform: translate(-50%);
            `
        default: 
            return `
                bottom: 10px;
                left: 50%;
                transform: translate(-50%);
                display: flex;
                width: 100%;
                justify-content: space-around;
            `
    }
}

function getPointStyle(style, checked, styleType) {
    const dot = `
        position: relative;
        border: 1px solid ${checked ? '#FFFFFF' : '#DADADA'};
        border-radius: 50%;
        & div {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: ${checked ? '#FFFFFF' : '#999999'};
        }
    `
    switch(style) {
        case POINT_STYLE.CIRCLE_COLUMN:
            return `
                width: 100%;
                padding-top: 100%;
                ${dot}
            `;
        case POINT_STYLE.CIRCLE_ROW:
            return `  
                display: inline-block;
                width: ${px2vw(22, 1440)};
                max-width: 22px;
                height: ${px2vw(22, 1440)};
                max-height: 22px;
                margin-right: ${px2percent(16, 693)};
                ${dot};
            `;
        case POINT_STYLE.POINT: 
        case POINT_STYLE.POINT_IN: 
        case POINT_STYLE.POINT_2:
            return `
                display: inline-block;
                border-radius: 50%;
                ${maxSize(9, styleType, 'width')};
                ${maxSize(9, styleType, 'height')};
                ${maxSize(16, styleType, 'margin-left', 6)};
                background-color: ${checked ? '#B69A67' : '#CFC4AE'};
            `
        default: 
            return `
                background-color: ${checked ? 'blue' : 'yellow'};
                height: 10px;
                width: 10px;
            `;

    }
}